/**
 * Routes
 */
/* eslint-disable */
import { OTPList } from 'components/AsyncComponent';
import { Layout, Section } from 'layout';
import { Redirect, Route, Switch } from 'react-router-dom';

const SmsOtpPage = ({ match }) => {
  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={OTPList} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default SmsOtpPage;
